export default __webpack_public_path__ + "static/media/tutorial_01.f2349ca3.gif";